import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/pagination/Pagination';
import Footer from '../components/footer/Footer';
import NewsService from '../../service/news/News';

interface NewsList {
  articleidx: number;
  bcode: string;
  userid: string;
  title: string;
  content: string;
  writetime: string;
  updatetime: string;
  branchcode: string;
  category: string;
  is_important: string;
  url: string;
  thumb: string | null;
}

function News() {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [newsData, setNewsData] = useState<NewsList[]>();
  const [totalCount, setTotalCount] = useState(0);

  const getList = async () => {
    try {
      const res = await NewsService.list(10, currentPage);
      setNewsData(res.data.list);
      setTotalCount(res.data.totalCount);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getList();
  }, [currentPage]);

  const dateFormat = (dateStr: string) => {
    const inputDate = new globalThis.Date(dateStr.replace(/-/g, '/')); // Safari 호환
    const now = new globalThis.Date();

    const diffMs = now.getTime() - inputDate.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffHours < 24) {
      return `${diffHours}시간 전`;
    } else if (diffDays < 7) {
      return `${diffDays}일 전`;
    } else {
      const yyyy = inputDate.getFullYear();
      const mm = String(inputDate.getMonth() + 1).padStart(2, '0');
      const dd = String(inputDate.getDate()).padStart(2, '0');
      return `${yyyy}.${mm}.${dd}`;
    }
  };
  return (
    <Container>
      <PageTop text="경공매 뉴스" />
      <List>
        {newsData &&
          newsData.map((item) => (
            <Item
              key={item.articleidx}
              onClick={() => window.open(item.url, '_blank')}
            >
              <Img
                src={
                  item?.thumb ? item.thumb : '/assets/images/no-image-news.png'
                }
              />
              <Description>
                <Title>{item.title}</Title>
                <Date> {dateFormat(item.updatetime)} </Date>
              </Description>
            </Item>
          ))}
      </List>
      <Bottom>
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(totalCount / 10)}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
          removeMargin={true}
        />
      </Bottom>
      <Footer />
    </Container>
  );
}

export default News;

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const List = styled.div`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const Item = styled.div`
  display: flex;
  padding: 16px 0px 24px 0px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-bottom: 1px solid #e1e2e4;
  cursor: pointer;

  &:last-child {
    border: none;
  }
`;

const Img = styled.img`
  width: 116px;
  object-fit: cover;
  border-radius: 8px;
  aspect-ratio: 29/20;
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;

const Title = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const NewsContent = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #616161;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Date = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  color: #616161;
`;

const Bottom = styled.div`
  display: flex;
  padding: 24px 0px 72px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;
